export default function (shantytown) {
    return shantytown.closedAt && shantytown.closedWithSolutions !== "yes";
}
